var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.259,
    height: 172.568,
    viewBox: "0 0 172.259 172.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#262e33;opacity:0.998;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M95.619,129.394a7.49,7.49,0,1,1-14.979,0v-33.7h-33.7a7.49,7.49,0,0,1,0-14.979h33.7v-33.7a7.49,7.49,0,0,1,14.979,0v33.7h33.7a7.49,7.49,0,1,1,0,14.979h-33.7ZM17.161,88.2A70.972,70.972,0,0,1,75.047,18.48l6.111-1.144V1.917L72.3,3.565a86.1,86.1,0,0,0,0,169.272l8.86,1.648V159.067l-6.111-1.144A70.972,70.972,0,0,1,17.161,88.2Zm86.8-84.635L95.1,1.919V17.336l6.111,1.144a70.931,70.931,0,0,1,0,139.442L95.1,159.066v15.417l8.858-1.648a86.1,86.1,0,0,0,0-169.268Z",
    transform: "translate(-2 -1.917)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.daae956e.svg";
export { ForwardRef as ReactComponent };